// Who the signed-in person is to the app: their user_access rows from public.my_access(), loaded once
// after sign-in. This only decides what the UI shows; the database (RLS + app.can()) is the security
// layer and refuses anything the UI might still offer.
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { supabase } from './supabaseClient';
import { computeAccess } from './accessModel';

export { computeAccess };

const AccessContext = createContext(computeAccess([]));

export function AccessProvider({ userKey, children, fallback }) {
  const [state, setState] = useState({ loading: true, error: null, access: computeAccess([]) });

  const load = useCallback(async () => {
    setState(s => ({ ...s, loading: true }));
    const { data, error } = await supabase.rpc('my_access');
    setState({ loading: false, error: error || null, access: computeAccess(error ? [] : data || []) });
  }, []);

  useEffect(() => { load(); }, [load, userKey]);

  if (state.loading) return fallback || null;
  return (
    <AccessContext.Provider value={{ ...state.access, error: state.error, reload: load }}>
      {children}
    </AccessContext.Provider>
  );
}

export function useAccess() {
  return useContext(AccessContext);
}
